import { httpBunny } from "@/common/axios";
import { BunnyNetCollectionsResponse } from "@/types";
import { captureException } from "@sentry/react";

export default class BunnyNet {
  public static async getCollections(): Promise<BunnyNetCollectionsResponse> {
    const response = await httpBunny.get(
      `/collections?page=1&itemsPerPage=100&orderBy=date&includeThumbnails=false`,
    );

    return response.data;
  }

  public static async getBunnyNetCollectionId(): Promise<string | undefined> {
    const collections = await BunnyNet.getCollections();
    return collections.items.find((item) => import.meta.env.MODE.startsWith(item.name))
      ?.guid;
  }

  public static async createVideo(placeRef: string | null) {
    const videoTitle = `review_place_${placeRef}_${new Date().toISOString()}`;
    const collectionId = await BunnyNet.getBunnyNetCollectionId();

    try {
      const response = await httpBunny.post("/videos", {
        title: videoTitle,
        collectionId,
      });

      console.log("bunnynet creation data:", response.data);

      return response.data.guid;
    } catch (error) {
      captureException(error);
      throw error;
    }
  }

  public static async uploadVideo(
    guid: string,
    video: File,
    onProgress?: (percent: number) => void,
  ) {
    try {
      const response = await httpBunny.put(`/videos/${guid}`, video, {
        headers: {
          "Content-Type": "application/octet-stream",
        },
        onUploadProgress: (progressEvent: ProgressEvent) => {
          try {
            if (onProgress && progressEvent.total) {
              const percent = Math.round(
                (progressEvent.loaded / progressEvent.total) * 100,
              );
              onProgress(percent);
            }
          } catch (err) {
            // swallow progress errors
          }
        },
      });

      console.log("bunnynet data:", response.data);
    } catch (error) {
      captureException(error);
      throw error;
    }
  }

  public static async deleteVideo(guid: string) {
    try {
      await httpBunny.delete(`/videos/${guid}`);
      console.log("video eliminated");
    } catch (error) {
      captureException(error);
      throw error;
    }
  }
}
